<template>
  <!-- Blog Area -->
  <div class="blog-details-area bg-white section-padding-xs"  v-if="infoData.categoryId==1">
    <div class="container">

      <article class="blog-item blog-item-details">
      <div class="blog-item-thumb">
        <a href="#">
          <img :src="blogImage()" :alt="infoData.title">
        </a>
      </div>
      <div class="blog-item-content">
        <h4 class="blog-item-title">{{infoData.title}}</h4>
        <div class="blog-item-meta">POSTED BY <b>BUKIBAGS.COM</b> {{_formatDate()}}</div>
        <p v-html="infoData.content">{{infoData.content}}</p>
      </div>
      <div class="blog-item-share">
        <h6>Share This Post: </h6>
        <div class="social-icons">
          <share></share>
        </div>
      </div>
    </article>
    </div>
  </div>
  <!--// Blog Area -->

  <!-- About Page Area -->
  <div class="about-area section-padding-xs" v-else-if="infoData.categoryId==2">
    <div class="container">
      <div class="row align-items-center ml-0 mr-0">
        <div class="about-content ml-0" v-html="infoData.content">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import request from '@/utils/request'
    import {formatDate} from '@/utils/date'
    import {setDocument} from '@/utils/documentSEO'
    import share from '@/components/share'
    export default {
        name: "detail",
        components:{
          share
        },
        data(){
          return {
            infoData:{
              albumPics: "",
              categoryId: 1,
              categoryName: "",
              collectCount: 100,
              commentCount: 100,
              content: "",
              createTime: "",
              description: "",
              id: 2,
              pic: "",
              title: "",
              keywords:""
            }
          }
        },
        methods:{
          _formatDate(){

            return formatDate(new Date(this.infoData.createTime),'yyyy-MM-dd hh:mm:ss')
          },
          blogImage(){
            if(this.infoData.albumPics!=null){
              let pics = this.infoData.albumPics.split(",")
              if(pics.length>0){
                return pics[0]
              }
            }
            return "/img/blog/blog-lg-image-3.jpg"
          },
          loadData(id){

            let _this = this
            request({
              url:"/subject/info/"+id,
              method:"GET"
            }).then(res=>{
              if(res.data.code===200){
                this.infoData = res.data.data

                setDocument(this.infoData.title,this.infoData.keywords,this.infoData.description)
                if(_this.$route.hash){
                  console.log(_this.$route.hash)
                  setTimeout(function(){
                    let t = $(_this.$route.hash).offset().top;
                    $(window).scrollTop(t-200);
                  },200)
                }
              }
            });

          }
        },
        created() {
          this.loadData(this.$route.params.id)
        },
        watch:{
          '$route.path':function(newVal,oldVal){
            this.loadData(newVal.params.id)
          }
        }
    }
</script>

<style scoped>

</style>
